module.exports = __webpack_public_path__ + "static/media/58-iveco-mercedes.7f10bb59.jpg";